import { FC, useContext } from "react";
import { ProductLabel } from "src/types/graphql.d";
import {
  PriceWrapper,
  StyledBrandName,
  StyledBrandNameLink,
  StyledProductHeading,
  StyledProductName,
} from "./ProductInfo.styled";
import { getI18nRoute } from "src/utils/i18nRoutes";
import { AppCtx } from "src/contexts/app.context";
import { Price } from "src/atoms/Price";
import PriceInfo from "src/molecules/ProductInfo/PriceInfo";
import { Flash } from "src/icons/Flash";
import { usePromotionContext } from "src/hooks/usePromotionContext";
import { useShopTypeContext } from "src/hooks/context/use-shop-type-context";
import { localeFix } from "src/utils/genderLocale/genderLocale";

interface Props {
  englishGenderId?: string;
  price: number;
  productName: string;
  labels: ProductLabel[];
  regularPrice: number;
  lowestPrice?: number | null;
  brandName: string;
  brandSlug: string;
  promoCode?: string;
}

const ProductInfo: FC<Props> = ({
  price,
  productName,
  regularPrice,
  lowestPrice,
  brandName,
  brandSlug,
  englishGenderId,
  promoCode,
}) => {
  const { locale } = useContext(AppCtx);
  const { promotionContextState } = usePromotionContext();
  const { currentShopType } = useShopTypeContext();

  return (
    <header>
      <StyledProductHeading as="h2" variant="h2">
        {brandSlug !== undefined ? (
          <StyledBrandNameLink
            data-testid="product-info-brand-name"
            href={`${getI18nRoute({
              route: `/brands`,
              locale,
            })}/${brandSlug}${getI18nRoute({
              route: `/${localeFix({ gender: currentShopType })}`,
              locale,
            })}`}
          >
            {brandName}
          </StyledBrandNameLink>
        ) : (
          <StyledBrandName data-testid="product-info-brand-name">
            {brandName}
          </StyledBrandName>
        )}
        &nbsp;
        <StyledProductName>{productName}</StyledProductName>
      </StyledProductHeading>
      <PriceWrapper>
        <p data-testid="product-info-price">
          <Price price={price} />
          {promoCode && !promotionContextState.hasPromotionEnded ? (
            <span className="promo-code">
              <Flash />
              {promoCode}
            </span>
          ) : null}
        </p>
      </PriceWrapper>
      <PriceInfo regularPrice={regularPrice} lowestPrice={lowestPrice} />
    </header>
  );
};

export default ProductInfo;
